'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeItem = changeItem;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* REDUX MAINTAIN ADMIN PAGE */

var CHANGE_ITEM = 'CHANGE_PAGE';

/*
 * ADMIN PAGE
 * String containing the current page
 * Eg: 'adminusers', 'adminmodules', 'adminhelp'
 */
var initialState = {
  adminPage: 'adminusers'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_ITEM:
      return (0, _extends3.default)({}, state, {
        adminPage: action.adminPage
      });
    default:
      return state;
  }
}

function changeItem(item) {
  return {
    type: CHANGE_ITEM,
    adminPage: item
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/adminState.js
// module id = 518
// module chunks = 0